import {
    MANUFACTURERS_OVERVIEW_GET_DATA_REQUEST,
    MANUFACTURERS_OVERVIEW_GET_DATA_RESULT,
} from 'Redux/actionTypes';

export const manufacturerGetDataRequest = (id) => ({
    type: MANUFACTURERS_OVERVIEW_GET_DATA_REQUEST,
    payload: id,
});

export const manufacturerGetDataResult = (result) => ({
    type: MANUFACTURERS_OVERVIEW_GET_DATA_RESULT,
    payload: result
});
